// extracted by mini-css-extract-plugin
export var buttonContent = "_4a-0";
export var centered = "_4a-1";
export var centeredFlex = "_4a-2";
export var errorText = "_4a-3";
export var icon = "_4a-4";
export var iconButtonContent = "_4a-5";
export var monospace = "_4a-6";
export var padded = "_4a-7";